module.exports = __webpack_public_path__ + "img/img_app_band_swim.c7e50792.png";